/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Button } from '../../UI';
import facebookIcon from '../../../assets/icons/facebook.svg';
/**
 * Renders the Facebook button
 *
 * @param  {(response: any) => void} [onClick]
 * @param  {string} [className]
 * @param  {string} [iconClassName]
 * @param  {string} [textClassName]
 *
 * @example
 * <FacebookButton
 *  onClick={}
 * />
 */
var FacebookButton = function (_a) {
    var onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? 'a6y-react-auth__facebook-btn' : _b, _c = _a.iconClassName, iconClassName = _c === void 0 ? '' : _c, _d = _a.textClassName, textClassName = _d === void 0 ? '' : _d, uiConfig = _a.uiConfig;
    return (React.createElement(Button, { role: 'button', className: className, onClick: onClick },
        React.createElement("img", { src: facebookIcon, alt: 'facebook-icon', className: iconClassName }),
        React.createElement("span", { className: textClassName }, (uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.buttonText) ? uiConfig.buttonText : 'Login with Facebook')));
};
export default FacebookButton;
//# sourceMappingURL=FacebookButton.js.map